'use strict';

import {getVueTemplate} from '../_imports/utils/utils.common';
import MediaVideoThumbnail from './media-video-thumbnail.main';
import {playVideoPlayer, prepareVideos} from '../../api/media/video';

const mediaVideo = {
    template: getVueTemplate('media-video'),
    components: {
        MediaVideoThumbnail
    },
    props: {
        video: Object,
        isGated: Boolean,
        gatedButtonLabel: String,
        ctaTracking: String
    },
    data() {
        return {
            videoElementId: null,
            videoProvider: null,
            videoCode: null,
            videoInlineStyles: null,
            aspectRatio: null
        }
    },
    created() {
        this.videoElementId = this.video.id;
        this.videoProvider = this.video.provider;
        this.videoCode = this.video.videoCode;
        this.aspectRatio = this.setAspectRatio();

        window.addEventListener('resize', this.resizeEvent);
    },
    watch: {
        isGated: {
            handler() {
                this.$nextTick(() => {
                    if (!this.isGated) {
                        this.renderWistiaVideo(this.$el);
                    }
                });
            },
            immediate: true
        }
    },
    methods: {
        resizeEvent() {
            if (this.$el
                && this.$el.nodeType !== 8) {
                const element = this.$el.querySelector('[am-video-player-front]');

                if (element) {
                    this.$emit('video-player-height', element.getBoundingClientRect().height);
                }
            }
        },
        clickPlayer() {
            if (!this.isGated) {
                playVideoPlayer(this.$el, {});
            }

            this.$emit('click');
        },
        hasMarketoCookie() {
            return Cookies.get('marketo_id');
        },
        renderWistiaVideo(videoPlayer) {
            if (this.videoProvider === 'wistia') {
                prepareVideos(videoPlayer);
            }
        },
        setAspectRatio() {
            if(this.video.width > 0) {
                return `${this.video.width} / ${this.video.height}`;
            }

            return `16 / 9`;
        }
    }
};

export default mediaVideo;
